module.exports = __webpack_public_path__ + "static/hcm-hero-bg-8ae7c096505c4adc5673c3b134a1a532.jpg";